import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ScreenTakeActionRoutingModule } from '@kp/screen-take-action/screen-take-action-routing.module';
import { SharedModule } from '@kp/shared/shared.module';

@NgModule({
  declarations: [ScreenTakeActionRoutingModule.components],
  imports: [CommonModule, ScreenTakeActionRoutingModule, SharedModule],
  exports: [ScreenTakeActionRoutingModule.components],
})
export class ScreenTakeActionModule {}
